// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: gZEhwnQAfx2q6zBpBNhhDQ
// Component: XPZlXsRBxmm-
import * as React from "react";
import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  hasVariant
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import { useScreenVariants as useScreenVariantseuyRl26Gw8Ft } from "./PlasmicGlobalVariant__Screen"; // plasmic-import: EuyRl26Gw8Ft/globalVariant
import "@plasmicapp/react-web/lib/plasmic.css";
import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import projectcss from "./plasmic_collect_wise_draft.module.css"; // plasmic-import: gZEhwnQAfx2q6zBpBNhhDQ/projectcss
import sty from "./PlasmicCreateSettlementModal.module.css"; // plasmic-import: XPZlXsRBxmm-/css

createPlasmicElementProxy;

export const PlasmicCreateSettlementModal__VariantProps = new Array();

export const PlasmicCreateSettlementModal__ArgProps = new Array();

const $$ = {};

function PlasmicCreateSettlementModal__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const globalVariants = ensureGlobalVariants({
    screen: useScreenVariantseuyRl26Gw8Ft()
  });
  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        plasmic_antd_5_hostless_css.plasmic_tokens,
        sty.root
      )}
    >
      <div
        data-plasmic-name={"title8"}
        data-plasmic-override={overrides.title8}
        className={classNames(
          projectcss.all,
          projectcss.__wab_text,
          sty.title8
        )}
      >
        {"Settlement Amount"}
      </div>
      <div
        data-plasmic-name={"amount"}
        data-plasmic-override={overrides.amount}
        className={classNames(projectcss.all, sty.amount)}
      />

      <div
        data-plasmic-name={"generateLinkButton"}
        data-plasmic-override={overrides.generateLinkButton}
        className={classNames(projectcss.all, sty.generateLinkButton)}
      >
        <div
          data-plasmic-name={"text"}
          data-plasmic-override={overrides.text}
          className={classNames(
            projectcss.all,
            projectcss.__wab_text,
            sty.text
          )}
        >
          {hasVariant(globalVariants, "screen", "medium")
            ? "Submit"
            : "Generate Link"}
        </div>
      </div>
    </div>
  );
}

const PlasmicDescendants = {
  root: ["root", "title8", "amount", "generateLinkButton", "text"],
  title8: ["title8"],
  amount: ["amount"],
  generateLinkButton: ["generateLinkButton", "text"],
  text: ["text"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicCreateSettlementModal__ArgProps,
          internalVariantPropNames: PlasmicCreateSettlementModal__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicCreateSettlementModal__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicCreateSettlementModal";
  } else {
    func.displayName = `PlasmicCreateSettlementModal.${nodeName}`;
  }
  return func;
}

export const PlasmicCreateSettlementModal = Object.assign(
  // Top-level PlasmicCreateSettlementModal renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    title8: makeNodeComponent("title8"),
    amount: makeNodeComponent("amount"),
    generateLinkButton: makeNodeComponent("generateLinkButton"),
    text: makeNodeComponent("text"),
    // Metadata about props expected for PlasmicCreateSettlementModal
    internalVariantProps: PlasmicCreateSettlementModal__VariantProps,
    internalArgProps: PlasmicCreateSettlementModal__ArgProps
  }
);

export default PlasmicCreateSettlementModal;
/* prettier-ignore-end */
